import Audio from "@frog/source/utility/Audio.js"

export default {
    "slug": "feast",
    "title": "Feast of Fools",
    "subtitle": "A game for LD56",
    "introduction": "a game for Ludum Dare 56",
    "image": require("@frog/source/assets/images/horror-tactics/titlescreen-title-doublesize.png"),
    "firstChapterKey": "1",
    "player": require("./player.js").default,
    "chapters": {
        "1": require("./1").default,
    },
    "configuration": {
        "darkness": "none",
        "renderBloodlust": true,
        "pixelated": true,
    },
    "failure": {
        "verb": "Consumed"
    },
    "credits": [
        {"name": "Anna Arkhipova", "position": "Art", "sprite": require("@frog/source/assets/images/horror-tactics/units/prof-mapsprite-yellow.png")}, // , "color": "#c73905"},
        {"name": "Liv McPherson", "position": "Code", "sprite": require("@frog/source/assets/images/horror-tactics/units/occultist-mapsprite-red.png")}, // , "color": "#860008"},
        {"name": "Andrew Goodenough", "position": "Design", "sprite": require("@frog/source/assets/images/horror-tactics/units/priest-mapsprite-blue.png")}, // , "color": "#0068bc"},
    ],
    "thanks": [
        "\"Mary Celeste\" Kevin MacLeod (incompetech.com)",
        "\"Chase Pulse Faster\" Kevin MacLeod (incompetech.com)",
        "\"Seven March\" Kevin MacLeod (incompetech.com)",
        "\"Classic Horror 2\" Kevin MacLeod (incompetech.com)",
        "\"Dance of Deception\" Kevin MacLeod (incompetech.com)",
        "Licensed under Creative Commons: By Attribution 4.0 License",
        "http://creativecommons.org/licenses/by/4.0/",
    ],
    "images": {
        "images": {
            // "priest": require("@frog/source/assets/images/horror-tactics/units/priest-mapsprite-white.png"),
            // "professor": require("@frog/source/assets/images/horror-tactics/units/prof-mapsprite-white.png"),
            // "occultist": require("@frog/source/assets/images/horror-tactics/units/occultist-mapsprite-white.png"),
            "artist": require("@frog/source/assets/images/horror-tactics/units/artist-mapsprite-white.png"),
            "priest": require("@frog/source/assets/images/horror-tactics/units/priest-mapsprite-blue.png"), // red
            "professor": require("@frog/source/assets/images/horror-tactics/units/prof-mapsprite-yellow.png"), // yellow
            "occultist": require("@frog/source/assets/images/horror-tactics/units/occultist-mapsprite-red.png"), // blue
            "thrall-priest": require("@frog/source/assets/images/horror-tactics/units/thrall-priest.png"),
            "thrall-professor": require("@frog/source/assets/images/horror-tactics/units/thrall-prof.png"),
            "thrall-occultist": require("@frog/source/assets/images/horror-tactics/units/thrall-occultist.png"),
            "monster-arms-red": require("@frog/source/assets/images/horror-tactics/units/monster-arms-red.png"),
            "monster-arms-blue": require("@frog/source/assets/images/horror-tactics/units/monster-arms-blue.png"),
            "monster-arms-yellow": require("@frog/source/assets/images/horror-tactics/units/monster-arms-yellow.png"),
            "monster-tentacle-red": require("@frog/source/assets/images/horror-tactics/units/monster-tentacle-red.png"),
            "monster-tentacle-blue": require("@frog/source/assets/images/horror-tactics/units/monster-tentacle-blue.png"),
            "monster-tentacle-yellow": require("@frog/source/assets/images/horror-tactics/units/monster-tentacle-yellow.png"),
            "monster-host": require("@frog/source/assets/images/horror-tactics/units/thehost-mapsprite-normal.png"),
            "monster-host-smile": require("@frog/source/assets/images/horror-tactics/units/thehost-mapsprite-smile.png"),
            "monster-host-transformed": require("@frog/source/assets/images/horror-tactics/units/thehost-mapspritetransformed.png"),
            "monster-host-transformed-eyes": require("@frog/source/assets/images/horror-tactics/units/thehost-mapsprite-eyes.png"),
        },
        "weapons": {
            "horror-axe": require("@frog/source/assets/images/horror-tactics/units/weapon.axe.png"),
            "horror-knife": require("@frog/source/assets/images/horror-tactics/units/weapon.knife.png"),
            "horror-candelabra": require("@frog/source/assets/images/horror-tactics/units/weapon.candelabra.png"),
            "horror-crucifix": require("@frog/source/assets/images/horror-tactics/units/weapon.crucifix-alt.png"),
            "horror-gun": require("@frog/source/assets/images/horror-tactics/units/weapon.gun.png"),
            "horror-shovel": require("@frog/source/assets/images/horror-tactics/units/weapon.shovel.png"),
        },
        "portraits": {
            "monster-host-smile": require("@frog/source/assets/images/horror-tactics/portraits/thehost-smile.png"),
            "monster-host-transformed": require("@frog/source/assets/images/horror-tactics/portraits/thehost-transformed.png"),
        },
        "misc": [
            require("@frog/source/assets/images/horror-tactics/warning-redo-1.png"),
            require("@frog/source/assets/images/horror-tactics/titlescreen-bgwithillust.png"),
            require("@frog/source/assets/images/horror-tactics/titlescreen-title-doublesize.png"),
            require("@frog/source/assets/images/horror-tactics/ui/undo-btn.png"),
            require("@frog/source/assets/images/horror-tactics/ui/undo-btn-hover.png"),
            require("@frog/source/assets/images/horror-tactics/ui/undo-btn-close.png"),
            require("@frog/source/assets/images/horror-tactics/ui/endturn-btn.png"),
            require("@frog/source/assets/images/horror-tactics/ui/endturn-btn-hover.png"),
            require("@frog/source/assets/images/horror-tactics/ui/endturn-btn-close.png"),
        ],
    },
    "audio": {
        "Music:Title": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/music/Classic Horror 2.mp3")),
        },
        "Music:Opening": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/music/Mary Celeste.mp3")),
        },
        "Music:Combat:1": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/music/Chase Pulse Faster.mp3")),
        },
        "Music:Combat:2": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/music/Seven March.mp3")),
        },
        "Music:Combat:Boss": {
            "volume": 0.4,
            "label": "music",
            "kill": {"label": "music"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/music/Dance of Deception.mp3")),
        },
        "Ambience": {
            "volume": 0.2,
            "label": "ambience",
            "kill": {"label": "ambience"},
            "loop": true,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/ambience-dungeon.mp3")),
        },
        "Tension:Opening": {
            "volume": 0.5,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/stinger-opening-reveal.mp3")),
        },
        "Tension:Closing": {
            "volume": 0.5,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/stinger-boss-reveal.mp3")),
        },
        "Scream": {
            "volume": 0.4,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/scream.mp3")),
        },
        "Scream2": {
            "volume": 0.4,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/scream2.mp3")),
        },
        "Dialogue:Blip": {
            "volume": 0.1,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move2.mp3")),
            ],
        },
        "Selection:Start": {
            "volume": 0.3,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/select-start.mp3")),
        },
        "Selection:Finish": {
            "volume": 0.3,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/select-finish.mp3")),
        },
        "Selection:Cancel": {
            "volume": 0.3,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/select-cancel.mp3")),
        },
        "Selection:Move": {
            "volume": 0.3,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move2.mp3")),
            ],
        },
        "EndTurn": {
            "volume": 0.5,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/endturn.mp3")),
        },
        "UndoAction": {
            "volume": 0.3,
            "type": "once:rotation",
            "audio": [
                // new Audio(require("@frog/source/assets/audio/horror-tactics/undo1.mp3")),
                // new Audio(require("@frog/source/assets/audio/horror-tactics/undo2.mp3")),
                // new Audio(require("@frog/source/assets/audio/horror-tactics/undo3.mp3")),
                // new Audio(require("@frog/source/assets/audio/horror-tactics/undo-1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/undo-2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/undo-3.mp3")),
            ]
        },
        "Unit:Attack:Melee": {
            "volume": 0,
        },
        "Unit:Attack:FinalHit": {
            "volume": 0,
        },
        "Unit:Attack:NoDamage": {
            "volume": 0,
        },
        "Unit:Attack:Monster": {
            "volume": 0.4,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-blood-1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-blood-2.mp3")),
            ]
        },
        "Unit:Attack:Knife": {
            "volume": 0.3,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-blunt-1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-blunt-2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-blunt-3.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-blunt-4.mp3")),
            ]
        },
        "Unit:Attack:Crucifix": {
            "volume": 0.3,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-holy-1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-holy-2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-holy-3.mp3")),
            ]
        },
        "Unit:Attack:Revolver": {
            "volume": 0.3,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-pistol-1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-pistol-2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-pistol-3.mp3")),
            ]
        },
        "Unit:Heal": {
            "volume": 0.3,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-holy-1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-holy-2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/attack-holy-3.mp3")),
            ]
        },
        "Unit:Pull": {
            "volume": 0.4,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull3.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull4.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull5.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull6.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/pull7.mp3")),
            ]
        },
        "Unit:Death": {
            "volume": 0.4,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/death1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/death2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/death3.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/death4.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/death5.mp3")),
            ]
        },
        "Unit:Death:Knell": {
            "volume": 0.5,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/death-knell.mp3"))
        },
        "Unit:Door": {
            "volume": 0.4,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/door1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/door2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/door3.mp3")),
            ]
        },
        "Unit:Door:Knell": {
            "volume": 0.5,
            "type": "once:rotation",
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/escape.mp3")),
        },
        "Unit:Move": {
            "volume": 0,
            // "type": "once:randomly",
            // "audio": [
            //     // ...
            // ]
        },
        "Chapter:Failure": {
            "volume": 0.3,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/failure.mp3")),
        },
        "Chapter:Success": {
            "volume": 0.3,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/success.mp3")),
        },
        "Unit:Monster:Spawn": {
            "volume": 0.2,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/ghost1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/ghost2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/ghost3.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/ghost4.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/ghost5.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/ghost6.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/ghost7.mp3")),
            ]
        },
        "Unit:Warning:Spawn": {
            "volume": 0.4,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/spawn1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/spawn2.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/spawn3.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/spawn4.mp3")),
            ]
        },
    },
    "steam": 4109740,
    "analytics": {
        "gameKey": "5db1f8009e0693558c9671ed6df1e080",
        "secretKey": "f37173aacf4474ddf951371f881eca67e92a5aa4",
    },
}
